import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import { DragDropContext, Droppable } from 'react-beautiful-dnd'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import DraggableHeading from './DraggableHeading'
import DroppableMergeField from './DroppableMergeField'
import Button from '../../../UniformComponents/Button'
import Select from '../../form/Select'

const defaultDroppableMergeFields = [
    'email',
    'salutation',
    'firstname',
    'lastname',
    'jobtitle',
    'companyname',
]

const EmaiLListMergeFieldModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.emailListMergeFieldModalVisible}
        onClose={distributeStore.closeEmailListMergeFieldModal}
        cssClass="x-large"
    >
        <Typography type="h2">{i18n.t('distributionMergeFieldModal.title')}</Typography>

        <br />

        {distributeStore.importProcessing
            ? (
                <div style={{ textAlign: 'center' }}>
                    <Typography type="h4">{i18n.t('distributionEmailList.mergingTitle')}</Typography>

                    <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText1')}</Typography>

                    <Typography type="tiny">{i18n.t('distributionEmailList.uploadingSubText2')}</Typography>
                </div>
            )
            : (
                <div>
                    <DragDropContext onDragEnd={distributeStore.onDragEnd}>
                        <div
                            style={{
                                display: 'flex',
                                gap: '20px',
                            }}
                        >
                            <div style={{ border: '1px solid grey', borderRadius: 6, padding: 16, width: '33%', height: 'min-content' }}>
                                <Typography type="b">{i18n.t('distributionMergeFieldModal.uploadedColumns')}</Typography>

                                <Typography>{i18n.t('distributionMergeFieldModal.dragAndDrop')}</Typography>

                                <br />

                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <Droppable
                                        style={{ width: 'inherit', height: 'inherit' }}
                                        isDropDisabled={false}
                                        test={1}
                                        droppableId="fileTargets"
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{ 
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px',
                                                }}
                                            >
                                                {distributeStore.fileTargets.map((heading, index) => (
                                                    <DraggableHeading
                                                        heading={heading}
                                                        index={index}
                                                        style={{ marginBottom: 10 }}
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </Droppable>
                                </div>
                            </div>

                            <div style={{ border: '1px solid grey', borderRadius: 6, padding: 16, width: '66%' }}>
                                <Typography type="b">{i18n.t('distributionMergeFieldModal.personalise')}</Typography>

                                <Typography>{i18n.t('distributionMergeFieldModal.ensure')}</Typography>

                                <br />

                                <div style={{ marginBottom: 20 }}>
                                    {defaultDroppableMergeFields.map((label) => (
                                        <DroppableMergeField
                                            title={label}
                                            droppableId={label}
                                            columns={distributeStore.columns.get(label)}
                                            removeItem={distributeStore.removeItem}
                                        />
                                    ))}
                                </div>

                                <hr />

                                <br />

                                <Typography type="b">{i18n.t('distributionMergeFieldModal.import')}</Typography>

                                <Typography>{i18n.t('distributionMergeFieldModal.merge')}</Typography>

                                <br />

                                <div>
                                    {distributeStore.addedQuestions.map((col) => {
                                        const row = distributeStore.questionTargets.get(col)
                                        return (
                                            <DroppableMergeField
                                                title={row.label}
                                                droppableId={row.label}
                                                columns={distributeStore.columns.get(row.label)}
                                                removeItem={distributeStore.removeItem}
                                                removeQuestion={distributeStore.removeTargetQuestion}
                                                colId={col}
                                            />
                                        )
                                    })}
                                </div>

                                <br />

                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 20,
                                    }}
                                >
                                    <Select
                                        label={i18n.t('addToQuestion.selectQuestion')}
                                        onBlur={distributeStore.changeSelectedQuestion}
                                        options={distributeStore.getSurveyQuestions()}
                                        value={distributeStore.selectedQuestion}
                                        style={{
                                            width: '60%',
                                        }}
                                    />

                                    <Button
                                        label={i18n.t('distributionEmailList.importIntoQuestion')}
                                        cssClass="regular tertiary"
                                        onClick={distributeStore.addQuestion}
                                    />
                                </div>
                            </div>
                        </div>
                    </DragDropContext>

                    <br />

                    <hr />

                    <br />

                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            label={i18n.t('cancel')}
                            cssClass="regular tertiary"
                            onClick={distributeStore.closeEmailListMergeFieldModal}
                        />

                        <Button
                            label={i18n.t('save')}
                            icon="far fa-floppy-disk"
                            cssClass="regular primary"
                            onClick={distributeStore.import}
                            loading={distributeStore.importProcessing}
                        />
                    </div>
                </div>
            )}
    </Modal>
)

export default observer(EmaiLListMergeFieldModal)
